
import { Nullable } from '@/shared/types/app.types'

export interface LocalPreformattedModalBasicFormState {
    id: Nullable<number>
    active: boolean
    title: string
}
export const initialLocalPreformattedModalBasicFormState =
    (): LocalPreformattedModalBasicFormState => ({
        id: null,
        active: true,
        title: ''
    })
